// extracted by mini-css-extract-plugin
export var content = "hero-module--content--dSlte";
export var jsAnimInit = "hero-module--jsAnimInit--GqLQv";
export var title_extra = "hero-module--title_extra--wesFr";
export var section = "hero-module--section--1htiX";
export var description = "hero-module--description--1Hfii";
export var title = "hero-module--title--2l0IN";
export var mediaWrap = "hero-module--mediaWrap--1fUMQ";